// extracted by mini-css-extract-plugin
module.exports = {"notification-btn":"NotificationAlert_notification-btn__1jHKY","icon-user":"NotificationAlert_icon-user__3AlgJ"};